import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';
import { DomSanitizer } from '@angular/platform-browser';

export interface GalleryImage {
  id: string;
  src: string;
  thumbnail?: string;
  alt: string;
  title?: string;
  subtitle?: string;
  description?: string;
  brand?: string;
  product_id?: string | number;
  service_center_id?: string | number;
  service_center_name?: string;
  hot_badge_enable: number;
  like_stats?: number;
  tire_model_name?: string;
}

@Component({
  selector: 'lib-web-shared-ui-gallery-detail',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatCardModule, RouterLink],
  templateUrl: './lib-gallery-detail.component.html',
  styleUrl: './lib-gallery-detail.component.scss',
})
export class LibGalleryDetailComponent implements OnInit, OnChanges {
  @Input() images: GalleryImage[] = [
    {
      id: '1',
      src: 'assets/images/honda-tire-1.jpg',
      alt: 'Honda กับยาง TOYO 1',
      title: 'Honda กับยาง TOYOddd',
      subtitle: '🔥',
      description:
        'Proxes CR1 มากกว่าความฝัน...เซียน กับที่สุดของสมรรถนะ บนถนนเปียกชื่อสุดแห่งการควบคุมให้การเดินทางที่ผ่อนลาดยาวง่ายระดับตัวลง เสียมาก Proxes CR1 มากกว่าความฝัน...เซียน กับที่สุดของสมรรถนะ บนถนนเปียกชื่อสุดแห่งการควบคุมให้การเดินทางที่ผ่อนลาดยาวง่ายระดับตัวลง เสียมาก Proxes CR1 มากกว่าความฝัน...เซียน กับที่สุดของสมรรถนะ สมรรถนะบนถนนเปียกชื่อสุดแห่งการควบคุม',
      brand: 'PROXES',
      hot_badge_enable: 1,
    },
    {
      id: '2',
      src: 'assets/images/honda-tire-2.jpg',
      alt: 'Honda กับยาง TOYO 2',
      title: 'Honda กับยาง TOYO',
      subtitle: '🔥',
      description: 'การติดตั้งยางรถยนต์คุณภาพสูงสำหรับ Honda ด้วยเทคโนโลยีขั้นสูง',
      brand: 'PROXES',
      hot_badge_enable: 1,
    },
  ];

  @Output() imageSelected = new EventEmitter<GalleryImage>();
  @Output() detailsRequested = new EventEmitter<GalleryImage>();
  @Output() galleryLiked = new EventEmitter<{ galleryId: number; ipAddress: string; isLiked: boolean }>();
  @Output() emitLinkUrl = new EventEmitter<{ url: string; startPosition: number }>();
  @Output() emitDataIndex = new EventEmitter();

  @Input() userIpAddress = '';
  @Input() galleryId = 0;
  @Input() galleryLikeCount = 0;
  @Input() galleryLikeStatus = 0; // 0 = not liked, 1 = liked

  public readonly replaceBucket = new ReplaceBucket();
  private readonly domSanitizer = inject(DomSanitizer);

  selectedImage: GalleryImage = this.images[0];
  selectedIndex = 0;

  // Track gallery like status (not individual images)
  isGalleryLiked = false;

  ngOnInit(): void {
    console.log('LibGalleryDetailComponent ngOnInit');
    console.log('galleryId:', this.galleryId);
    console.log('userIpAddress:', this.userIpAddress);
    console.log('galleryLikeCount:', this.galleryLikeCount);
    console.log('galleryLikeStatus:', this.galleryLikeStatus);

    if (this.images.length > 0) {
      this.selectedImage = this.images[0];
      this.selectedIndex = 0;
    }
    // Set gallery like status from input
    this.isGalleryLiked = this.galleryLikeStatus === 1;
    console.log('isGalleryLiked set to:', this.isGalleryLiked);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('LibGalleryDetailComponent ngOnChanges', changes);

    if (changes['galleryLikeCount']) {
      console.log(
        'galleryLikeCount changed from',
        changes['galleryLikeCount'].previousValue,
        'to',
        changes['galleryLikeCount'].currentValue
      );
    }

    if (changes['galleryLikeStatus']) {
      console.log(
        'galleryLikeStatus changed from',
        changes['galleryLikeStatus'].previousValue,
        'to',
        changes['galleryLikeStatus'].currentValue
      );
      this.isGalleryLiked = this.galleryLikeStatus === 1;
    }
  }

  selectImage(image: GalleryImage, index: number): void {
    this.selectedImage = image;
    this.selectedIndex = index;
    this.emitDataIndex.emit(index);
    this.imageSelected.emit(image);
    console.log('index:', index);
  }

  viewDetails(): void {
    this.detailsRequested.emit(this.selectedImage);
  }

  // Keyboard navigation for accessibility
  onThumbnailKeyDown(event: KeyboardEvent, image: GalleryImage, index: number): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.selectImage(image, index);
    }
  }

  // Gallery like functionality
  toggleGalleryLike(): void {
    console.log('toggleGalleryLike called');
    console.log('galleryId:', this.galleryId);
    console.log('userIpAddress:', this.userIpAddress);
    console.log('current galleryLikeCount:', this.galleryLikeCount);
    console.log('current isGalleryLiked:', this.isGalleryLiked);

    // For debugging - allow function to continue even without galleryId/userIpAddress
    if (!this.galleryId || !this.userIpAddress) {
      console.warn('Gallery ID or IP address not available for like functionality - continuing anyway for debugging');
      console.warn('galleryId:', this.galleryId, 'userIpAddress:', this.userIpAddress);
      // Don't return - continue with local update
    }

    // Toggle gallery like status locally for immediate UI feedback
    this.isGalleryLiked = !this.isGalleryLiked;

    // Update like count locally for immediate feedback
    if (this.isGalleryLiked) {
      this.galleryLikeCount += 1;
    } else {
      this.galleryLikeCount = Math.max(0, this.galleryLikeCount - 1);
    }

    console.log('after update - galleryLikeCount:', this.galleryLikeCount);
    console.log('after update - isGalleryLiked:', this.isGalleryLiked);

    // Only emit if we have valid data
    if (this.galleryId && this.userIpAddress) {
      // Emit event to parent component to handle API call
      this.galleryLiked.emit({
        galleryId: this.galleryId,
        ipAddress: this.userIpAddress,
        isLiked: this.isGalleryLiked,
      });
    }
    this.galleryLiked.emit();
  }

  // Test function to verify click events work
  testClick(): void {
    console.log('TEST CLICK WORKS!');
    alert('Test click works!');
  }

  // Get the correct like icon based on gallery like status
  getGalleryLikeIcon(): string {
    return this.isGalleryLiked ? 'assets/icons/icon-Like-2.png' : 'assets/icons/icon-Like-1.png';
  }

  // Get current gallery like count
  getGalleryLikeCount(): number {
    console.log('getGalleryLikeCount called, returning:', this.galleryLikeCount);
    return this.galleryLikeCount;
  }

  // Update gallery like status from parent (after API response)
  updateGalleryLikeStatus(likeCount: number, likeStatus: number): void {
    this.galleryLikeCount = likeCount;
    // this.galleryLikeStatus = likeStatus;
    // this.isGalleryLiked = likeStatus === 1;
  }

  // Revert optimistic updates on API error
  revertGalleryLikeStatus(): void {
    // Revert the like status
    this.isGalleryLiked = !this.isGalleryLiked;

    // Revert the like count
    if (this.isGalleryLiked) {
      this.galleryLikeCount += 1;
    } else {
      this.galleryLikeCount = Math.max(0, this.galleryLikeCount - 1);
    }
  }
  getSafeHtml(htmlString: string) {
    return this.domSanitizer.bypassSecurityTrustHtml(htmlString);
  }
  openDialogGallery(link_url: string) {
    console.log('Opening dialog for image at index:', this.selectedIndex);
    console.log('Image URL:', link_url);
    console.log('Selected Image:', this.selectedImage);

    this.emitLinkUrl.emit({ url: link_url, startPosition: this.selectedIndex });

    // Dispatch resize event after a short delay to ensure dialog is rendered
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }
}
